import { useMemo } from 'react';

import Lottie from 'react-lottie';

import animationData from './insights_loader_animation.json';
import { StyledAIAgentAnimatedLoaderContainer } from './styles';

export type AIAgentAnimatedLoaderProps = {
  width?: number;
  height?: number;
};

export const AIAgentAnimatedLoader = ({ width = 255, height = 255 }: AIAgentAnimatedLoaderProps) => {
  const animationOptions = useMemo(() => ({ animationData, autoplay: true, loop: true }), []);
  return (
    <StyledAIAgentAnimatedLoaderContainer width={width} height={height} data-automation="AIAgentAnimatedLoader">
      <Lottie options={animationOptions} />
    </StyledAIAgentAnimatedLoaderContainer>
  );
};
